import OffscreenCanvas from '../../classes/PhotoEditor/OffscreenCanvas';

export function drawImageOnCanvas(source, sx = 0, sy = 0, sw, sh, dx = 0, dy = 0, dw, dh) {
  const sWidth = sw || source.width;
  const sHeight = sh || source.height;
  const dWidth = dw || sWidth;
  const dHeight = dh || sHeight;
  const canvas = new OffscreenCanvas(dWidth, dHeight);
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(source, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
  return canvas;
}

export function renderChecker({ colors, width, height }) {
  const canvas = new OffscreenCanvas(width, height);
  const halfWidth = width / 2;
  const halfHeight = height / 2;
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = false;

  ctx.fillStyle = colors[0];
  ctx.fill(new Path2D(`M0 0H${halfWidth}V${height}H${width}V${halfHeight}H0V0Z`));

  ctx.fillStyle = colors[1];
  ctx.fill(new Path2D(`M${halfWidth} 0H${width}V${halfHeight}H0V${height}H${halfWidth}V0Z`));

  return canvas;
}
